import { Injectable } from '@angular/core';
import { HttpService } from '../../../../shared/services/http/http-client.service';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class LogFinanceiraService {

  constructor(
    private httpService: HttpService
  ) { }
 
  logMonitoramento(data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doGet('/agendaFinanceira/buscar', data, successHandle, errorHandle);

  }

}
